import { UserMe } from "@/models/user";

const PAYLOAD_KEY = "auth_token_payload";
const AUTH_COOKIE_NAME = "connect.sid";

const getTokenPayload = (): Promise<UserMe | null> => {
  const storedItem = localStorage.getItem(PAYLOAD_KEY);
  return Promise.resolve(storedItem ? JSON.parse(storedItem) : null);
};

const setTokenPayload = (tokenPayload: UserMe): Promise<void> =>
  Promise.resolve(localStorage.setItem(PAYLOAD_KEY, JSON.stringify(tokenPayload)));

const removeTokenPayload = (): Promise<void> =>
  Promise.resolve(localStorage.removeItem(PAYLOAD_KEY));

const clearAuthenticationSession = (): Promise<void> => {
  removeTokenPayload();

  if (typeof document !== "undefined") {
    document.cookie = `${AUTH_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  }

  return Promise.resolve();
};

export { getTokenPayload, setTokenPayload, removeTokenPayload, clearAuthenticationSession };
